import React from "react";
import { Mail, MapPin, Navigation, Phone } from "lucide-react";
import { SITE } from "../lib/site";

const Map = () => (
  <section className="relative bg-slate-100">
    <iframe
      title="The International School location"
      className="block h-[26rem] w-full border-0 md:h-[30rem]"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      src="https://maps.google.com/maps?q=24.8451466%2C67.0510606&z=16&hl=en&output=embed"
    />
    <div className="pointer-events-none absolute inset-0 flex items-end px-4 pb-6 sm:px-6 md:items-center md:pb-0">
      <div className="pointer-events-auto mx-auto w-full max-w-7xl">
        <div className="max-w-sm rounded-2xl bg-white p-6 shadow-lift">
          <p className="font-display text-lg font-extrabold text-navy-800">Visit our campus</p>
          <p className="mt-3 flex gap-2 text-sm text-slate-600">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden /> {SITE.address}
          </p>
          <p className="mt-2 flex gap-2 text-sm text-slate-600">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden />
            <span>
              <span className="whitespace-nowrap">UAN {SITE.uan}</span> &middot; <span className="whitespace-nowrap">{SITE.tel}</span> &middot;{" "}
              <span className="whitespace-nowrap">{SITE.phone}</span>
            </span>
          </p>
          <p className="mt-2 flex gap-2 text-sm text-slate-600">
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden /> {SITE.email}
          </p>
          <a
            href={SITE.mapUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 rounded-xl bg-navy-800 px-4 py-2.5 text-sm font-bold text-white hover:bg-navy-900"
          >
            <Navigation className="h-4 w-4" aria-hidden /> Get directions
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Map;
